<template>
	<div class="dropdown">
		<button class="btn btn-sm btn-neutral rounded-pill dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
			Más opciones
		</button>
		<ul class="dropdown-menu">
			<li v-if="route.name != 'company.admin.setting.index'"><router-link :to="{ name: 'company.admin.setting.index' }" class="dropdown-item"><i class="bi bi-building pe-2"></i>Perfil de la empresa</router-link></li>
			<li v-if="route.name != 'company.admin.setting.config'"><router-link :to="{ name: 'company.admin.setting.config' }" class="dropdown-item"><i class="bi bi-gear pe-2"></i>Configuración de la empresa</router-link></li>
			<li v-if="route.name != 'company.admin.setting.exchange'"><router-link :to="{ name: 'company.admin.setting.exchange' }" class="dropdown-item"><i class="bi bi-currency-exchange pe-2"></i>Tipos de cambio</router-link></li>
		</ul>
	</div>
</template>

<script>
	import { useRoute } from 'vue-router';

	export default {
		setup() {
			const route = useRoute();

			return { route };
		}
	}
</script>